export default __webpack_public_path__ + "static/media/mwallet2.cd9628cf.png";